export const LMS_ROLES = {
  teacher: "teacher",
  parent: "parent",
};

const ROLE_KEYS = ["lmsRole", "role", "accountType", "userType", "type"];

export const normalizeLmsRole = (role) => {
  const normalizedRole = String(role || "").toLowerCase();
  return normalizedRole === LMS_ROLES.parent ? LMS_ROLES.parent : LMS_ROLES.teacher;
};

export const getLmsRole = ({ currentUser, credObj } = {}) => {
  const roleFromUser = ROLE_KEYS.map((key) => currentUser?.[key]).find(Boolean);
  const roleFromCredential = ROLE_KEYS.map((key) => credObj?.[key]).find(Boolean);
  return normalizeLmsRole(roleFromUser || roleFromCredential);
};

export const isParentRole = (role) => normalizeLmsRole(role) === LMS_ROLES.parent;
